<template>
  <div>
    <div class="box">
      <div class="title">仓储信息手动同步设置</div>
      <div>
        <el-card>
          <div class="box-card">
            <div>手动同步按钮刷新时间（分钟）</div>
            <el-input
              placeholder=""
              v-model="btnRefreshGroup.value"
              @blur="(event) => onBlur(event, btnRefreshGroup)"
              @focus="onFocus"
              oninput="value=value.replace(/[^\d]/g,'')"
            >
            </el-input>
          </div>
        </el-card>
      </div>
    </div>
    <div class="box">
      <div class="title">果园管理派发走访任务设置</div>
      <div>
        <el-card>
          <div class="box-card">
            <div>派发走访任务刷新时间（天）</div>
            <el-input
              placeholder=""
              v-model="taskRefreshGroup.value"
              @blur="(event) => onBlur(event, taskRefreshGroup)"
              @focus="onFocus"
              oninput="value=value.replace(/[^\d]/g,'')"
            >
            </el-input>
          </div>
        </el-card>
      </div>
    </div>
    <div class="box">
      <div class="title">客户溯源页面模板设置</div>
      <div>
        <el-card>
          <div class="box-card box-card-to" @click="handleSetting">
            <div>客户溯源页面模板设置</div>
            <div class="el-icon-d-arrow-right arrow"></div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 弹窗区域 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :fullscreen="mFullscreen"
      :before-close="cancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :top="'3vh'"
    >
      <div slot="title">
        <DialogHead :title="title" :mFullscreen.sync="mFullscreen" @cancel="cancel"></DialogHead>
      </div>
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
        @on-upload="handleFile"
      ></component>
      <span slot="footer">
        <el-button :disabled="loading || fileUploading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button
          :disabled="fileUploading"
          :loading="loading"
          class="line-button"
          @click="submitFrom"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DialogHead from '@/components/innerDialogHead.vue'
import myform from '@/views/system/setting/components/form'
import { getSettingList, saveSettingByKey } from '@/api/system/manage'
export default {
  components: {
    DialogHead,
    myform,
  },
  data() {
    return {
      title: '',
      currentView: '',
      mFullscreen: false,
      dialogVisible: false,

      loading: false,
      fileUploading: false,

      oldValue: '',
      btnRefreshGroup: {
        id:'',
        groupIndex: 0,
        name: '手动同步按钮刷新时间（分钟）',
        code: 'handOperateRefreshTime',
        value: ''
      },
      taskRefreshGroup: {
        id:'',
        groupIndex: 1,
        name: '派发走访任务刷新时间（天）',
        code: 'visitTaskRefreshTime',
        value: ''
      },
      traceabilityModelGroup: {
        id:'',
        groupIndex: 2,
        name: '客户溯源页面模板设置',
        code: 'customerTraceabilityTemplate',
        value: '',
        extra: ''
      },
    }
  },
  created() {
    this.getSettingList()
  },
  methods: {
    handleFile(file) {
      this.fileUploading = file.fileUploading
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.fileUploading = false
          this.cancel()
          this.getSettingList()
        })
        .catch(() => {
          this.loading = false
          this.fileUploading = false
        })
    },
    cancel() {
      if (this.loading || this.fileUploading) {
        return
      }
      this.dialogVisible = false
    },
    handleSetting() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.title = '客户溯源页面模板设置'
      this.$nextTick(() => {
        this.$refs[this.currentView].getData(this.traceabilityModelGroup.code)
      })
    },
    //保存
    onBlur(event, group) {
      if (this.oldValue == event.target.value) return
      this.handleUpdate(group)
    },

    onFocus(event) {
      this.oldValue = event.target.value
    },
    async handleUpdate(groupMap) {
      let result = await saveSettingByKey(groupMap)
      if (result.code == 200 && result.flag) {
        this.getSettingList()
      } else {
        this.$message.error(result.message)
      }
    },
    getSettingList() {
      getSettingList()
        .then((res) => {
          if (res.flag) {
            let groupEnums = ['btnRefreshGroup', 'taskRefreshGroup', 'traceabilityModelGroup']
            if(res.data && res.data.length > 0) {
              res.data.forEach(r=>{
                groupEnums.forEach(group=>{
                  let groupExit = res.data.find(d=>d.code == this[group].code)
                  if(!groupExit) this[group].value = 30
                  if(!groupExit?.value) r.value = 30
                  if(this[group].code == r.code){
                    this[group] = Object.assign(this[group],r)
                  }
                })
              })
            }else{
              groupEnums.forEach(group=>{
                this[group].value = 30
              })
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped lang='less'>
::v-deep {
  .el-dialog{
    border-radius: 10px;
    margin-bottom: 0;
    .line-button {
      background-color: #c59429;
      color: #ffffff;
      border-color: #c59429;
      margin-left: 20px;
    }
  }
}
.box{
  margin-bottom: 30px;
}
.title {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 16px;
}
.box-card{
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  font-size: 14px;
  .arrow{
    font-size: 32px;
    margin-left: 20px;
  }
}
.box-card-to{
  cursor: pointer;
}
</style>